module.exports = __webpack_public_path__ + "img/logo_blue_title.png?ada343ddf9364cb199e64a361e4680e7";